import {Component, OnInit} from "@angular/core";
import {New} from "../new";
import {NewService} from "../new.service";
import {Router} from "@angular/router";
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container2">
        <div class="title-clothes">
        2025/06/18 - "DONIC" 2025 BLUEGRIP系列 膠皮火熱上市🔥🔥

        </div>

        <p class="news_content_wrap">
        張繼科代言2025 DONIC 的 BLUEGRIP J1 及J2 膠皮到貨
        快來購買🆕感受全新體驗🏃🏃
        DONIC 的 BLUEGRIP J 系列新款膠皮，結合了兩大膠皮系列的優勢。在中國乒壇巨星、DONIC 新合作夥伴張繼科的參與與指導下，誕生了這款結合 BLUESTAR A 系列與 BLUEGRIP C 系列精華的新品。
        這款膠皮採用了 BLUESTAR A 的膠面配方作為基礎，搭配與 BLUEGRIP C 系列相同的海綿結構與顆粒幾何設計，造就出一款符合最高競技要求的膠皮——動能十足、極具旋轉威力、擊球強勁，同時又保有良好手感。
        
        本店只售
        • BLUEGRIP J-1 55°：較硬版本
        • BLUEGRIP J-2 52.5°：中硬度版本
        海綿厚度：max.
        膠皮顏色：🟥紅色 / ⬛️黑色
        張繼科本人在開發過程中投入無數測試與調校，精心打磨各項細節，最終呈現出這款融合兩大經典膠皮優點的全新混血之作——DONIC BLUEGRIP J 系列。而這款冠上「J」名號的新膠皮，也可說是張繼科實至名歸的代表作。
        </p> 
        
        <div class="detailimg">
        <img src="../../../img/detail4/img1.jpg" height="900px" class="detailautoimg">
        </div>


        
       <button class="sharebutton" (click)="Facebook()"><img src="../../../img/fb-live-map_2.png" width="60px"></button>
       <button class="sharebutton" (click)="Google()"><img src="../../../img/photo.jpg" width="50px"></button>
       <button class="sharebutton" (click)="Twitter()"><img src="../../../img/Twitter.png" width="50px"></button>
      
       </div>
       
       
       
       <div class="new_button" style="text-align: center;margin-bottom: 30px;width:150px;margin:auto;margin-bottom:30px;">
       <button style="color: white;background-color: #CC3366;border: none;" (click)="gotoHome()">回到首頁</button></div>
    `,
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class Detail4Component implements OnInit{
  public ptitle:string;
  public pcontent:string;
  constructor(private newservice:NewService,private router:Router){}
  ngOnInit(){
    this.ptitle=this.newservice.getTitle()
    
    this.pcontent=this.newservice.getContent()
  }
  gotoHome(){
    this.router.navigate(['/']);
  }
  Facebook() {
    void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href)) ));
  }
  Google(){
    void(window.open('https://lineit.line.me/share/ui?url='.concat(encodeURIComponent(location.href)) ));
  }

  Twitter(){
    void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(location.href))));
  }


}



// WEBPACK FOOTER //
// ./src/app/news/detail/detail4.component.ts